module.exports = __webpack_public_path__ + "static/img/49.cdb46ba.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/49.png
// module id = vOVI
// module chunks = 1